import { render, staticRenderFns } from "./Gruppen.vue?vue&type=template&id=fa7a4fa2&"
import script from "./Gruppen.vue?vue&type=script&lang=js&"
export * from "./Gruppen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports